import { NoteSearchIcon } from './NoteSearchIcon';

/**
 * author: Colton Wiscombe
 * id D914BB12-8F9A-4B71-86A0-DA016AA91B90
 * name note-search
 * version: 5.7.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/note-search.svg
 * tags
 */
export const PostItNoteSearchIcon = NoteSearchIcon;
export default PostItNoteSearchIcon